import { render, staticRenderFns } from "./CoverageGroupsPricingTable.vue?vue&type=template&id=7677c1d3"
import script from "./CoverageGroupsPricingTable.vue?vue&type=script&lang=js"
export * from "./CoverageGroupsPricingTable.vue?vue&type=script&lang=js"
import style0 from "./CoverageGroupsPricingTable.vue?vue&type=style&index=0&id=7677c1d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
